import {Role} from "types/Role";
import {dateTime} from "services/date";

/**
 * Transform the given role by deserializing object properties
 *
 * @internal
 * @param role
 */
export default function deserializeRole(role: any): Role {
    role.created_at = dateTime(role.created_at)
    role.updated_at = dateTime(role.updated_at)

    return role;
}